export default "__VITE_ASSET__BeSXtb6D__"